import React from 'react';

const WalletSkeleton = () => {
  return (
    <div className="p-4 sm:p-6 min-h-56 h-full bg-customs-lavender-foreground border border-customs-lavender dark:bg-background-accent  rounded-lg overflow-hidden animate-pulse" />
  );
};

export default WalletSkeleton;
